import React, { useState, useContext, useEffect } from "react";
import { Modal, Col, Form, Row, Button } from "react-bootstrap";
// import { isMobile } from 'react-device-detect';
import ContextApp from "../../../../core/contexts/context.app";
import { useNavigate, useLocation } from "react-router-dom";
import ServiceStorage from "../../../../core/services/service.storage";
import _ from "lodash";
import getCityDataAndSaveToStorage from "./GetCityListAndSaveToStorage";
import { IconLocation } from "../../../css/icons";
// import { IconErrorCircle, IconLocation } from "../../../assets/icons";
function SelectCityModal({ showModalSelectCity, setShowModalSelectCity }) {
  let navigate = useNavigate();
  let location = useLocation();
  const screenWidth = window.innerWidth;
  const ctx = useContext(ContextApp);

  const handleClose = () => {
    setShowModalSelectCity(false);
  };
  const [regions, setRegions] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { regoinResult, newUpdateDate } =
          await getCityDataAndSaveToStorage();
        ServiceStorage.setCity({
          cityListLastUpdate: newUpdateDate,
          cityList: regoinResult,
          selectedCity: ctx.selectedCity,
        });
        setRegions(regoinResult);

        setLoadingData(true);
      } catch (error) {
        setLoadingData(false);
        console.log("error => ", error);
      }
    })();
  }, []);

  const selectedCity = (item) => {
    ctx.setSelectedCity(item);
    ServiceStorage.setSelectedCity(item);
    setShowModalSelectCity(false);
    navigate("/tourism");
  };

  return (
    <>
      <Modal
        onHide={handleClose}
        show={showModalSelectCity}
        className={screenWidth < 575 && " modal-bottom "}
      >
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title id="contained-modal-title-vcenter">
            شهر مورد نظر خود را انتخاب نمایید
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className=" pt-0 rounded-4 mt-0 ">
          {!loadingData ? (
            <div className="pt-5">در حال دریافت اطلاعات ...</div>
          ) : (
            <>
              <Row className="gx-2">
                {regions?.map((item, key) => {
                  return (
                    <Col xs="6" key={key}>
                      <button
                        className="mt-2 py-2 btn text-start btn-light border fs-085 rounded-2 w-100 text-dark text-end"
                        onClick={() => {
                          selectedCity(item);
                        }}
                      >
                        <IconLocation width="16px" fillColor="#444" />{" "}
                        {item.name}
                      </button>
                    </Col>
                  );
                })}
              </Row>

              <div className="my-2 pt-2 fs-075  bg-white border-top w-100 text-secondary">
                {/* <IconErrorCircle fillColor="#444" /> */}
                به زودی سایر شهرهای ایران به این لیست اضافه می شوند...{" "}
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SelectCityModal;
